import React from 'react';

import { styled } from '@mui/material/styles'

import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LabelIcon from '@mui/icons-material/Label';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

import { Catalog } from '../states/settingState';

type Props = {
  open: boolean;
  currentActId: string;
  currentCatalogId: string;
  catalogs?: Catalog[];
  handleCommit: (catalogId: string, actId: string) => void;
  handleClose: () => void;
};

const HenResultCatalogListItem = styled(ListItemButton)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  paddingLeft: theme.spacing(0),
}));
const SyoResultCatalogListItem = styled(ListItemButton)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  paddingLeft: theme.spacing(2),
}));
const SetuResultCatalogListItem = styled(ListItemButton)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  paddingLeft: theme.spacing(4),
}));
const KanResultCatalogListItem = styled(ListItemButton)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  paddingLeft: theme.spacing(6),
}));
const MokuResultCatalogListItem = styled(ListItemButton)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  paddingLeft: theme.spacing(8),
}));

export const CatalogUpdateMoveActDialog: React.FC<Props> = (props) => {

  const handleSelectCatalog = (catalogId) => {
    props.handleCommit(catalogId, props.currentActId);
  };

  const createCatalog = (level: number, c: Catalog) => {
    const disabled = (c.id === props.currentCatalogId) || (c.child && c.child.length > 0);

    return level === 0 ? (
      <HenResultCatalogListItem key={`catalog-${c.id}-${level}`} disabled={disabled} onClick={() => handleSelectCatalog(c.id)}>
        <ListItemIcon><LabelIcon /></ListItemIcon>
        <ListItemText primary={c.name} />
      </HenResultCatalogListItem>
    ) : level === 1 ? (
      <SyoResultCatalogListItem key={`catalog-${c.id}-${level}`} disabled={disabled} onClick={() => handleSelectCatalog(c.id)}>
        <ListItemIcon><LabelIcon /></ListItemIcon>
        <ListItemText primary={c.name} />
      </SyoResultCatalogListItem>
    ) : level === 2 ? (
      <SetuResultCatalogListItem key={`catalog-${c.id}-${level}`} disabled={disabled} onClick={() => handleSelectCatalog(c.id)}>
        <ListItemIcon><LabelIcon /></ListItemIcon>
        <ListItemText primary={c.name} />
      </SetuResultCatalogListItem>
    ) : level === 3 ? (
      <KanResultCatalogListItem key={`catalog-${c.id}-${level}`} disabled={disabled} onClick={() => handleSelectCatalog(c.id)}>
        <ListItemIcon><LabelIcon /></ListItemIcon>
        <ListItemText primary={c.name} />
      </KanResultCatalogListItem>
    ) : (
      <MokuResultCatalogListItem key={`catalog-${c.id}-${level}`} disabled={disabled} onClick={() => handleSelectCatalog(c.id)}>
        <ListItemIcon><LabelIcon /></ListItemIcon>
        <ListItemText primary={c.name} />
      </MokuResultCatalogListItem>
    );
  }

  const fTree = (level: number, cs: Catalog[], view: React.JSX.Element[]) => {
    cs.forEach((c, index) => {
      if (c.id === '9999') return;
      view.push((
        <Paper key={`catalogs-${level}-${c.id}`}
         sx={{
            minWidth: 275,
            margin: 1,
          }} elevation={3}>
          <List>
            {createCatalog(level, c)}
          </List>
        </Paper>
      ));

      if (c.child && c.child.length > 0) {
        fTree(level + 1, c.child, view);
      }
    });
  };

  const createCatalogs = () => {
    const view: React.JSX.Element[] = [];
    if (props.catalogs && Array.isArray(props.catalogs)) {
      fTree(0, props.catalogs, view);
    }

    return (
      <>
        {view}
      </>
    )
  };

  return (
    <Dialog
      open={props.open}
      keepMounted
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{"選択した体系目次の最後尾に文書を移動します"}</DialogTitle>
      <DialogContent>
        {createCatalogs()}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="primary">
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );

};
